import { connection } from "@/lib/connection";

/**
 * Obtiene el PDF de una compra invocando al endpoint local (BFF).
 * El access token se manda al BFF y se propaga al API real.
 */
export async function downloadCompraPDF(compraId: string, accessToken: string): Promise<Blob> {
    return connection<Blob>(
        `/api/compras/${compraId}/pdf`,
        'GET',
        { 'X-Compra-Access-Token': accessToken },
        null,
        undefined,
        false,
        true
    );
}
